
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const CustomerDetailsDialog = ({ open, onClose, customerDetails }) => {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      if (!customerDetails || !open) return;
      setLoading(true);
      try {
        const subdomain = window.location.hostname.split('.')[0];
        const token = localStorage.getItem("token");
        const apiUrl = `https://${subdomain}.restocash.app/api/customer/info/${customerDetails.id}?api_password=Project102$_`;

        const response = await fetch(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.message);
        setDetails(data.data);
      } catch (err) {
        console.error("❌ فشل في جلب تفاصيل العميل:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomerDetails();
  }, [customerDetails, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>تفاصيل العميل</DialogTitle>
      <DialogContent>
        {loading ? (
          <Typography>جارٍ تحميل البيانات...</Typography>
        ) : details ? (
          <Box>
            <Typography variant="h6">👤 {details.customer.name}</Typography>
            <Typography>📞 {details.customer.phone1}</Typography>
            <Typography>📧 {details.customer.email || "لا يوجد"}</Typography>
            <Typography>📍 {details.customer.address1 || "-"}</Typography>

            <Typography sx={{ mt: 2 }} variant="h6">🧾 الفواتير:</Typography>
            {details.invoices.map((inv) => (
              <Accordion key={inv.id}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>طلب رقم: {inv.order_id} – {inv.date}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>الفرع: {inv.root_name}</Typography>
                  <Typography>نوع الطلب: {inv.order_type}</Typography>
                  <Typography>الإجمالي: {inv.total_amount}</Typography>
                  <Typography>الخدمة: {inv.service}</Typography>
                  <Typography>الضريبة: {inv.tax}</Typography>
                  <Typography>الخصم: {inv.discount}</Typography>
                  <Typography>الكاشير: {inv.cashier_name}</Typography>
                  <Typography>تم بواسطة: {inv.user_name}</Typography>

                  <Typography sx={{ mt: 1 }}>💳 المدفوعات:</Typography>
                  {inv.payments.map((p) => (
                    <Box key={p.id} sx={{ pl: 2, mb: 1 }}>
                      <Typography>المبلغ: {p.amount}</Typography>
                      <Typography>الطريقة: {p.payment_method}</Typography>
                      <Typography>بتاريخ: {p.created_at}</Typography>
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ) : (
          <Typography>لم يتم العثور على بيانات.</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>إغلاق</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerDetailsDialog;
